export default __webpack_public_path__ + "static/media/AddIcon.2cb9b85d.svg";